export enum FileServiceProviderType {
  LOCAL_FILE_SYSTEM = 'LOCAL_FILE_SYSTEM',
  SHARE_POINT_365 = 'SHARE_POINT_365',
  WEB_DAV = 'WEB_DAV',
}
